import React from "react";
import {formatNumber} from "utils/formatter";
import {Tag} from "antd";

const  statColor = {
  paid: "success",
  unpaid: "error",
  partial: "processing",
}

export const columns = [
  {
    title: 'BRANCH',
    key: 'branch',
    render: (data) => data.branch.name
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    align: 'center',
  },
  {
    title: 'DATE',
    dataIndex: 's_date',
    key: 's_date',
    align: 'center',
  },
  {
    title: 'CUSTOMER',
    key: 'customer',
    render: (data) => data.customer.name
  },
  {
    title: 'STATUS',
    dataIndex: 'payment_status',
    key: 'payment_status',
    align: 'center',
    render: (payment_status) => <Tag color={statColor[payment_status]}>{payment_status}</Tag>
  },
  {
    title: 'AMOUNT',
    dataIndex: 'total',
    key: 'total',
    align: 'right',
    render: (total) => formatNumber(total)
  },
];
